import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PMS_CATEGORY_CARD_COLOR, PMS_CATEGORY_CARD_ICON } from "constants/constants";
import { useLanguage } from "context/LanguageContext";

const PmsCategoryCard = ({ id="", title="", totalForms=0, setFocusedCardId }) => {
      const { language } = useLanguage();
    return (
        <div
            key={id}
            className="group relative bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 cursor-pointer hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-blue-200 hover:scale-105 card-hover-lift"
            onClick={() => setFocusedCardId(id)}
        >
            <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-white text-xl font-bold bg-gradient-to-br ${PMS_CATEGORY_CARD_COLOR(title)}`}>
                    <FontAwesomeIcon icon={PMS_CATEGORY_CARD_ICON(title)} />
                </div>
                <div className="text-right">
                    <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2 py-1 rounded-full">
                        {totalForms} {language ? 'forms' : 'نموذج'}
                    </span>
                </div>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                {title}
            </h3>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                    <FontAwesomeIcon icon={faArrowRight} className="text-white text-sm" />
                </div>
            </div>
            <div className="absolute top-4 right-4">
                <div className="w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                    {totalForms}
                </div>
            </div>
        </div>
    )
}

export default PmsCategoryCard;